"use strict";
/**
 * created by ma.rongqin 2017-3-3
 * 媒立方上传视频至吉木萨尔县在线的指令
 */
angular.module('trsZjolUploadDirective', [])
    .directive('trsZjolUpload', ['$q', '$sce', 'httpService', 'modalDialog', function($q, $sce, httpService, modalDialog) {
        return {
            restrict: 'EA',
            replace: true,
            transclude: true,
            scope: {
                isLocalUpload: '@',
                callback: '='
            },
            templateUrl: './utils/trsZjolUpload/trsZjolUpload_tpl.html',
            controller: function($scope, $element) {},
            link: function(scope, element, attr) {
                initStatus();
                initData();
                /**
                 * [initStatus description]初始化状态
                 */
                function initStatus() {
                    scope.status = {
                        isLocalUpload: angular.isDefined(scope.isLocalUpload) && scope.isLocalUpload == "true" ? true : false,
                    };
                    scope.data = {
                        src: ''
                    };
                }
                /**
                 * [initData description]初始化数据
                 */
                function initData() {
                    // getServiceTime().then(function(time) {
                    //     time = Math.round(time / 1000);
                    //     // return encodeSign(time);
                    // }).then(function(params) {
                    scope.data.src = "http://m.v.zjol.com.cn/a/mlf/uploadVideo.shtml?time=" + Math.round() + "&token="
                    scope.data.src = $sce.trustAsResourceUrl(scope.data.src);
                    // });
                    //初始化监听
                    initListener();
                }
                /**
                 * [getServiceTime description]获取当前服务器时间
                 */
                // function getServiceTime() {
                //     var defer = $q.defer();
                //     var params = {
                //         'serviceid': "mlf_fusion",
                //         'methodname': "getServiceTime",
                //     };
                //     httpService.http("/wcm/mlfcenter.do", params, "get").then(function(data) {
                //         var time = String(new Date(data.LASTOPERTIME).getTime());
                //         defer.resolve(time);
                //     });
                //     return defer.promise;
                // }
                /**
                 * [encodeSign description]加密
                 */
                // function encodeSign(time) {
                //     var defer = $q.defer();
                //     var key = "5rWZ5rGf6KeG55WM5aqS56uL5pa5";
                //     var encodeParams = {
                //         serviceid: 'mlf_metadata',
                //         methodname: 'encode',
                //         pwd: time + key
                //     };
                //     httpService.http("/wcm/mlfcenter.do", encodeParams, 'get').then(function(data) {
                //         var afterEncode = data.key.replace(/"/g, '');
                //         var params = {
                //             time: time,
                //             token: afterEncode
                //         };
                //         defer.resolve(params);
                //     });
                //     return defer.promise;
                // }
                /**
                 * [initListener description]初始化监听上传事件
                 */
                function initListener() {
                    window.addEventListener('message', function(e) {
                        if (!!e && angular.isString(e.data)) {
                            var msg = e.data;
                            if (!msg.indexOf("progress")) {
                                var progress = msg.split('=')[1];
                                if (angular.isDefined(scope.callback)) {
                                    scope.callback.progress(progress);
                                }
                            } else if (!msg.indexOf("complete")) {
                                var id = msg.split('=')[1];
                                $('#uploadToZjolIframe').attr('src', $('#uploadToZjolIframe').attr('src'));
                                if (angular.isDefined(scope.callback)) {
                                    scope.callback.complete(id);
                                }
                            } else if (!msg.indexOf("type")) {
                                modalDialog.alertType('上传失败', '请按照要求上传文件', 'error', false);
                                return;
                            }
                        }
                    }, false);
                }
                /**
                 * [upload description]上传
                 */
                scope.upload = function() {
                    window.frames[0].postMessage('upload', 'http://m.v.zjol.com.cn');
                };
            }
        };
    }]);